import React, { useState, useEffect } from "react"
import InternalNavItem from "./InternalNavItem"

import { InternalNavContainer, Nav, TitleWrapper, PrimaryList } from "./style"

const internalNavItems = [
  {
    label: "Why Canberra",
    nestedItems: [
      { label: "item1", link: "/" },
      { label: "item2", link: "/" },
      { label: "item3", link: "/" },
    ],
  },
  {
    label: "Setup",
    nestedItems: [
      { label: "item1", link: "/" },
      { label: "item2", link: "/" },
      { label: "item3", link: "/" },
    ],
  },
  {
    label: "Grow",
    nestedItems: [
      {
        label: `Why expand your business in Canberra?`,
        link: "/",
      },
      {
        label: `Export Goods & Services`,
        link: "/",
      },
      { label: "Innovative ideas & applications", link: "/" },
      { label: "Recruit & retain talent", link: "/" },
    ],
  },
  {
    label: "Connect",
    nestedItems: [
      { label: "item1", link: "/" },
      { label: "item2", link: "/" },
      { label: "item3", link: "/" },
    ],
  },
]
const InternalNav = ({ page }) => {
  const [itemClicked, setItemClicked] = useState(2)

  return (
    <InternalNavContainer>
      <TitleWrapper>
        <h3>In this section</h3>
      </TitleWrapper>
      <Nav>
        <PrimaryList>
          {internalNavItems.map((item, index) => {
            return (
              <InternalNavItem
                key={index}
                label={item.label}
                link={"/"}
                nestedItems={item.nestedItems}
                id={index}
                itemClicked={itemClicked}
                setItemClicked={setItemClicked}
              />
            )
          })}
        </PrimaryList>
      </Nav>
    </InternalNavContainer>
  )
}

export default InternalNav
